/*
 *
 * Api constants
 *
 */

export const LOGIN_DOMAIN = 'app/Login/LOGIN_DOMAIN';
export const LOGIN_REGISTER = 'app/Login/LOGIN_REGISTER';